import React, { useState } from "react";
import styles from "../assets/scss/pagesScss/project.module.scss";
import { projects } from "../assets/config/config";
import Hearder from "../component/common/header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";

const ProjectsList = () => {
    const [currentPage, setCurrentPage] = useState({ ongoing: 1, completed: 1 });
    const projectsPerPage = 6; // Number of projects per page

    const getPaginatedProjects = (category, page) => {
        const filteredProjects = projects.filter(project => project.category === category);
        const startIndex = (page - 1) * projectsPerPage;
        return filteredProjects.slice(startIndex, startIndex + projectsPerPage);
    };

    const ongoingProjects = getPaginatedProjects("Ongoing", currentPage.ongoing);
    const completedProjects = getPaginatedProjects("Completed", currentPage.completed);

    const getTotalPages = (category) => {
        return Math.ceil(projects.filter(p => p.category === category).length / projectsPerPage);
    };

    const renderPagination = (category) => (
        <div className={styles.pagination}>
            <button
                disabled={currentPage[category.toLowerCase()] === 1}
                onClick={() => setCurrentPage(prev => ({ ...prev, [category.toLowerCase()]: prev[category.toLowerCase()] - 1 }))}>
                Prev
            </button>
            <span>{currentPage[category.toLowerCase()]} / {getTotalPages(category)}</span>
            <button
                disabled={currentPage[category.toLowerCase()] === getTotalPages(category)}
                onClick={() => setCurrentPage(prev => ({ ...prev, [category.toLowerCase()]: prev[category.toLowerCase()] + 1 }))}>
                Next
            </button>
        </div>
    );

    const renderProjects = (projects, title) => (
        <section className={styles.projectSection}>
            <h6>Our Projects</h6>
            <h2 className={styles.title}>{title} Projects</h2>
            <p className={styles.description}>A streamlined approach to managing and showcasing our latest and completed projects.</p>
            <div className={styles.projectGrid}>
                {projects.map(project => (
                    <div key={project.id} className={styles.projectCard} onClick={() => window.location.href = `/project/${project.id}`}>
                        <div className={styles.img}>
                            <img src={project.thumbnail} alt={project.title} className={styles.image} />
                        </div>
                        <div className={styles.info}>
                            <span className="date">
                                <FontAwesomeIcon icon={faCalendarAlt} />{" "}
                                {dayjs(project.date).format("MMM DD, YYYY")}
                            </span>
                            <h3 className={styles.projectTitle}>{project.title}</h3>
                            <p className={styles.projectInfo}>Specialty Restaurant Group</p>
                        </div>
                    </div>
                ))}
            </div>
            {/* {renderPagination(title)} */}
        </section>
    );

    return (
        <div className={styles.projectContainer}>
            <Hearder title="Our Projects" breadcrumb="Projects" />
            <section>
                <div className="container">
                    {renderProjects(ongoingProjects, "Ongoing")}
                </div>
            </section>
            <section className={styles.completed}>

            <div className="container">
                {renderProjects(completedProjects, "Completed")}
            </div>
            </section>
        </div>
    );
};

export default ProjectsList;